import { Component, Input, OnChanges, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CampaignsReceiptAdminApiClient, ImportUserConsumption, StaffPointStrategy, TimeConstraint } from 'src/app/api/api-campaigns.service.generated';
import { GUID } from 'src/app/common/utils/GuidUtils';
import { S3Upload } from 'src/app/common/utils/S3Upload';
import { TimeConstraintComponent } from '../_/time-constraint/time-constraint.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ButtonComponent } from "wecheer-common";
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-staff-point-strategy-receipt',
  templateUrl: './staff-point-strategy-receipt.component.html',
  styleUrls: ['./staff-point-strategy-receipt.component.scss'],
  imports: [
    MatSlideToggleModule,
    MatIconModule,
    TimeConstraintComponent,
    ReactiveFormsModule,
    FlexLayoutModule,
    ButtonComponent
  ]
})
export class StaffPointStrategyReceiptComponent implements OnInit, OnChanges {
  private campaignReceiptApi = inject(CampaignsReceiptAdminApiClient);
  private snackBar = inject(MatSnackBar);


  @Input() strategy: StaffPointStrategy;
  @Input() campaignId: string;

  form = new FormGroup({
    receiptTimeConstraintEnabled: new FormControl(),
    receiptTimeConstraint: new FormControl(),
    checkExternalId: new FormControl(false)
  });

  constructor() {
    this.form.get('receiptTimeConstraintEnabled').valueChanges.subscribe(enabled => {
      if (!enabled)
        this.form.patchValue({ receiptTimeConstraint: undefined });
    });
  }

  ngOnChanges(): void {
    if (!this.strategy) return;
    this.setFormValue(this.strategy);
  }

  async ngOnInit() {
  }

  setFormValue(model: StaffPointStrategy) {

    this.form.patchValue({
      ...model,
      receiptTimeConstraintEnabled: !!model.receiptTimeConstraint,
      checkExternalId: model.checkExternalId
    });

  }

  getFormValue(model: StaffPointStrategy) {
    if (!this.form.valid) {
      this.forceValidatorsToDisplayErrors();
      return null;
    }
    const f = this.form.value;

    model.receiptTimeConstraint = f.receiptTimeConstraintEnabled ? this.getReceiptTimeConstraint(f.receiptTimeConstraint) : undefined;
    model.checkExternalId = f.checkExternalId;

    return model;
  }

  getReceiptTimeConstraint(receiptTimeConstraint: any): TimeConstraint {
    if (!receiptTimeConstraint)
      return undefined;

    var vReceiptTimeConstraint = new TimeConstraint();
    vReceiptTimeConstraint.init(receiptTimeConstraint);
    return vReceiptTimeConstraint;
  }

  forceValidatorsToDisplayErrors() {
    Object.keys(this.form.controls).forEach(key => {
      this.form.get(key).markAsTouched();
      this.form.get(key).markAsDirty();
    });
  }

  async onSubmit() {
  }

  async importFromCsv(event) {
    let files = event.target.files;
    if (files.length === 0) {
      return;
    }

    let fileToUpload = <File>files[0];
    let model: ImportUserConsumption = new ImportUserConsumption();
    let uploadKey = await this.uploadFile(fileToUpload, model);

    if (!uploadKey) {
      return;
    }
    model.uploadKey = uploadKey;
    model.fileName = fileToUpload.name;
    model.campaignId = this.campaignId;
    this.snackBar.open('Importing of user consumptions has been started', "Decline", { duration: 3000 });

    await lastValueFrom(this.campaignReceiptApi.importUserConsumption(model));
  }

  async uploadFile(file, model) {
    try {
      let uploadKey = `${GUID.newGuid().replace(/-/g, '')}.${file.name.split('.').pop()}`; // preserve extension on s3 key
      let uploadUrl = await lastValueFrom(this.campaignReceiptApi.getImportFileUploadUrlS3(uploadKey));
      const uploadSuccess = await lastValueFrom(S3Upload.upload(uploadUrl, file));
      if (uploadSuccess) {
        return uploadKey;
      } else {
        await lastValueFrom(this.campaignReceiptApi.sendMailErrorImportFile('Failed to upload CSV.', model));
        return null;
      }
    } catch (err) {
      await lastValueFrom(this.campaignReceiptApi.sendMailErrorImportFile('Failed to upload CSV.', model));
      this.snackBar.open('Failed to import user consumptions', "Decline", { duration: 3000 });
    }
  }

}
